interface AppConfigType {
    BASE_URL: any;
    ISSSOENABLED: boolean;
    SHOW_VERSION_SELECTOR: boolean;
    SHOW_VERSION_SELECTOR_TC:boolean;
    SHOW_VERSION_SELECTOR_SC:boolean;
}

export const AppConfig: AppConfigType = {
    BASE_URL: process.env.REACT_APP_API_BASE_URL,
    ISSSOENABLED: true,
    SHOW_VERSION_SELECTOR: process.env.REACT_APP_SHOW_VERSION_SELECTOR === 'true',
    SHOW_VERSION_SELECTOR_TC:process.env.REACT_APP_SHOW_VERSION_SELECTOR === 'true',
    SHOW_VERSION_SELECTOR_SC:process.env.REACT_APP_SHOW_VERSION_SELECTOR === 'true',
};